import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 助力状态
 */
class State extends UltMeta {
    UP_SHELF = new Meta(0, "助力失败");
    DOWN_SHELF = new Meta(1, "助力成功");
}

export const STATE = new State();


